/* Libraries */
import React from 'react';
import cn from 'classnames';

/* Components */
import { Icon } from 'ht-styleguide';

/* Utils */
import { noop } from '@utils/event';

/* Constants */
import { ICON_ORIENTATION } from './constants';

/* Styles */
import styles from './menu.module.scss';

/* Types */
type ItemWithCaretProps = Partial<{
  containerStyles: string;
  iconName: string;
  iconStyles: string;
  iconOrientation: string;
  iconOpenStyles: string;
  isOpen: boolean;
  onClick: BaseAnyFunction;
  text: string;
  textStyles: string;
  textOpenStyles: string;
  datatestid?: string;
}>;

const ItemWithCaret = ({
  containerStyles,
  iconName = 'chevron',
  iconStyles = styles.chevron,
  iconOpenStyles = styles.chevronUp,
  iconOrientation = ICON_ORIENTATION.right,
  isOpen = false,
  onClick = noop,
  text,
  textStyles,
  textOpenStyles = '',
  datatestid,
}: ItemWithCaretProps) => {
  const appliedTextStyles = cn(textStyles, {
    [textOpenStyles]: isOpen,
  });
  const appliedIconStyles = cn(iconStyles, {
    [iconOpenStyles]: isOpen,
  });
  const iconIsLeft = iconOrientation === ICON_ORIENTATION.left;
  const iconIsRight = iconOrientation === ICON_ORIENTATION.right;

  return (
    <div onClick={onClick} className={containerStyles} data-testid={datatestid}>
      {iconIsLeft && <Icon name={iconName} className={appliedIconStyles} />}
      <span className={appliedTextStyles}>{text}</span>
      {iconIsRight && <Icon name={iconName} className={appliedIconStyles} />}
    </div>
  );
};

export default React.memo(ItemWithCaret);
